// eslint-disable
// this is an auto generated file. This will be overwritten

export const createEntity = `mutation CreateEntity($input: CreateEntityInput!) {
  createEntity(input: $input) {
    id
    name
    legacyId
    tags
    centers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    programs {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const updateEntity = `mutation UpdateEntity($input: UpdateEntityInput!) {
  updateEntity(input: $input) {
    id
    name
    legacyId
    tags
    centers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    programs {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const deleteEntity = `mutation DeleteEntity($input: DeleteEntityInput!) {
  deleteEntity(input: $input) {
    id
    name
    legacyId
    tags
    centers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    programs {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const createCenter = `mutation CreateCenter($input: CreateCenterInput!) {
  createCenter(input: $input) {
    id
    name
    legacyId
    tags
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    spaces {
      items {
        id
        name
        version
      }
      nextToken
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const updateCenter = `mutation UpdateCenter($input: UpdateCenterInput!) {
  updateCenter(input: $input) {
    id
    name
    legacyId
    tags
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    spaces {
      items {
        id
        name
        version
      }
      nextToken
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const deleteCenter = `mutation DeleteCenter($input: DeleteCenterInput!) {
  deleteCenter(input: $input) {
    id
    name
    legacyId
    tags
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    spaces {
      items {
        id
        name
        version
      }
      nextToken
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const createProgram = `mutation CreateProgram($input: CreateProgramInput!) {
  createProgram(input: $input) {
    id
    name
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const updateProgram = `mutation UpdateProgram($input: UpdateProgramInput!) {
  updateProgram(input: $input) {
    id
    name
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const deleteProgram = `mutation DeleteProgram($input: DeleteProgramInput!) {
  deleteProgram(input: $input) {
    id
    name
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const createSpace = `mutation CreateSpace($input: CreateSpaceInput!) {
  createSpace(input: $input) {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentGroups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const updateSpace = `mutation UpdateSpace($input: UpdateSpaceInput!) {
  updateSpace(input: $input) {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentGroups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const deleteSpace = `mutation DeleteSpace($input: DeleteSpaceInput!) {
  deleteSpace(input: $input) {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentGroups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const createGroup = `mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentSpace {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentGroups {
        nextToken
      }
      version
    }
    program {
      id
      name
      entity {
        id
        name
        legacyId
        version
      }
      groups {
        nextToken
      }
      version
    }
    defaultTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    defaultChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    version
  }
}
`;
export const updateGroup = `mutation UpdateGroup($input: UpdateGroupInput!) {
  updateGroup(input: $input) {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentSpace {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentGroups {
        nextToken
      }
      version
    }
    program {
      id
      name
      entity {
        id
        name
        legacyId
        version
      }
      groups {
        nextToken
      }
      version
    }
    defaultTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    defaultChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    version
  }
}
`;
export const deleteGroup = `mutation DeleteGroup($input: DeleteGroupInput!) {
  deleteGroup(input: $input) {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentSpace {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentGroups {
        nextToken
      }
      version
    }
    program {
      id
      name
      entity {
        id
        name
        legacyId
        version
      }
      groups {
        nextToken
      }
      version
    }
    defaultTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    defaultChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    version
  }
}
`;
export const createTeacher = `mutation CreateTeacher($input: CreateTeacherInput!) {
  createTeacher(input: $input) {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const updateTeacher = `mutation UpdateTeacher($input: UpdateTeacherInput!) {
  updateTeacher(input: $input) {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const deleteTeacher = `mutation DeleteTeacher($input: DeleteTeacherInput!) {
  deleteTeacher(input: $input) {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const createChild = `mutation CreateChild($input: CreateChildInput!) {
  createChild(input: $input) {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const updateChild = `mutation UpdateChild($input: UpdateChildInput!) {
  updateChild(input: $input) {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const deleteChild = `mutation DeleteChild($input: DeleteChildInput!) {
  deleteChild(input: $input) {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
